<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Payment Amount">
                 <FormRow> 
                      <AmountSelectorSimple/>                    
                      <ErrorLabel field="amount" />
                    </FormRow>
                </FormSection>                 
                <FormSection title="Personal Information">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>      
                    <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>                                    
                    <DonorAddress />
                </FormSection>
                <FormSection title="">
										<FormRow>
												<FormLabel class="control-label">
													Notes
											</FormLabel>
										</FormRow>									
										<FormRow>
											<FormInput type="textarea" class="width-half" field="custom.Notes"/>                      
										</FormRow> 
								</FormSection>                 
                <FormSection title="Payment Information" last>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                </FormSection>
                <PaymentButton showAmount btnText="Checkout"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>


<script lang="ts">
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  setup() {
    const { setValue, form } = usePaymentForm()

    setValue('description', 'OU Press Purchase')
    setValue('gateway','SensepassCardknoxOUSpec')
    return {
      form,
      setValue
    }
  },
})
</script>
<style scoped lang="scss">
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}

h3{
    text-align: center;
    margin-top: 10px;
    font-size: 23px;
    margin-bottom: 0px;
    padding-bottom: 13px;
}

::v-deep .oudonate-other-amount.USD {
  .amount_other__wrapper::before {
    padding: 11px 8px;
    border-right: 1px solid #ddd;
    height: auto;
}
}
::v-deep .form-container.ou-donation-form {
    margin: 4px 0px;
    padding: 0px;
    box-shadow: none;
}

</style>

